import SubdivisionName from "./SubdivisionName"
import { Doc, Id } from "#convex/_generated/dataModel.js"
import SubdivisionToggleButton from "./SubdivisionToggleButton"

export default function NeighborhoodLabel({ subdivisions, subdivision }: { subdivisions: Doc<"Subdivision">[], subdivision: Id<"Subdivision"> | null }) {
  if(subdivisions == null || subdivisions.length == 0) {
    return <></>
  }
  if(subdivisions && subdivisions.length == 1) {
    return <div className="p-3 text-xs uppercase text-darkBlue"><SubdivisionName subdivision={subdivisions[0]!._id} /></div>
  } else if(subdivisions && subdivisions.length > 1) {
    return <SubdivisionToggleButton subdivisions={subdivisions.filter(s => s != null) as Doc<"Subdivision">[]} subdivision={subdivision} />
  }
    return <p>Resident</p>
}